import { type AccessorialCharge, type RawAccessorialCharge } from '../domain/QuoteAccessorial'
import { type BookNowItem, type BookNowStatus } from '../domain/Rate'

export type SubmitRateParams = {
  id: string
  flatRate: number
  notes?: string
  accessorials?: Array<AccessorialCharge>
  requestedAccessorials?: Array<AccessorialCharge>
}

export type RawSubmitRateParams = {
  flat_rate: number
  notes: string
  accessorials?: Array<RawAccessorialCharge>
  requested_accessorials?: Array<RawAccessorialCharge>
}

export type RejectRateParams = {
  id: string
  reason: string
}

export type RawBookNowItem = {
  uuid: string
  status: 'created' | 'booked' | 'failed'
  status_reason: string | null
  rate: string
  shipment_link: string | null
}

export type RawBookNowStatus = {
  uuid: string
  status: 'created' | 'processing' | 'finished'
  items: Array<RawBookNowItem>
}

export function mapRateToApi(rate: SubmitRateParams): RawSubmitRateParams {
  return {
    flat_rate: rate.flatRate,
    notes: rate.notes ?? '',
    accessorials: rate.accessorials ?? [],
    requested_accessorials: (rate.requestedAccessorials ?? []).map(requestedAccessorialCharge => ({
      price_item_type: requestedAccessorialCharge.priceItemType,
      stop_type: requestedAccessorialCharge.stopType,
      notes: requestedAccessorialCharge.notes,
      rate: requestedAccessorialCharge.rate,
      unit: requestedAccessorialCharge.unit,
    })),
  }
}

export function mapApiToBookNowItem(bookNowItem: RawBookNowItem): BookNowItem {
  return {
    uuid: bookNowItem.uuid,
    status: bookNowItem.status,
    statusReason: bookNowItem.status_reason || undefined,
    rate: bookNowItem.rate,
    shipmentLink: bookNowItem.shipment_link || undefined,
  }
}

export function mapApiToBookNowStatus(bookNowStatus: RawBookNowStatus): BookNowStatus {
  const items: Array<BookNowItem> = (bookNowStatus.items ?? []).map(mapApiToBookNowItem)
  return {
    uuid: bookNowStatus.uuid,
    status: bookNowStatus.status,
    items: items,
  }
}
